import { onDOMContentLoaded } from "tsi-common-react/src/utils/events";
import { getHash } from "tsi-common-react/src/utils/urls";

import { getDocument } from "@thelabnyc/thelabui/src/utils/dom";

// Add attribute to fix inconsitent anchoring to PDP reviews
const reviewsElem = "reviews__body";
const hash = getHash(reviewsElem);
if (hash) {
    onDOMContentLoaded.on(async () => {
        const document = getDocument();
        document?.body.setAttribute("scrollToReviews", hash.toString());
    });
}
